import React, { useContext } from "react";
import { UserContext } from "../../App";
import styles from "./Tabs.styles.scss";

const Tabs = () => {
    const { step } = useContext(
        UserContext
    );

    const routes = [
        {
            path: "/escolha-um-ambiente",
            label: "Escolha um ambiente",
        },
        {
            path: "/opcao-de-ambiente",
            label: "Selecione uma opção",
        },
        {
            path: "/selecione-um-padrao",
            label: "Selecione um padrão",
        },
        {
            path: "/compartilhar/:id",
            label: "Finalizar",
        },
    ];
    return (
        <ul className="tabs-component">
            {routes.map((route, index) => (
                <li
                    key={route.path}
                    className={`${(step === (index + 1)) ? "show-label" : ""}`}
                >
                    <a className={`${step > index ? "active" : ""}`}>
                        <span className="tab-index">{index + 1}</span>{" "}
                        <div className="tab-label">{route.label}</div>
                    </a>
                </li>
            ))}
        </ul>
    );
};

export default Tabs;
